import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tmin-height: 32px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tpadding: 16px 32px;\n\tborder: 2px solid;\n\tmin-width: 100px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import atomize from '@quarkly/atomize';
import { Text, Link, Strong } from '@quarkly/widgets';
var NoEndPoint = atomize.div(_templateObject());
var Wrapper = atomize.div(_templateObject2());
var url = 'https://formspree.io/';

var Formspree = function Formspree(props) {
  var children = props.children,
      _props$endpoint = props.endpoint,
      endpoint = _props$endpoint === void 0 ? '' : _props$endpoint,
      errorMessage = props.errorMessage,
      completeText = props.completeText,
      rest = _objectWithoutProperties(props, ["children", "endpoint", "errorMessage", "completeText"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      complete = _useState2[0],
      setComplete = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      fetching = _useState4[0],
      setFetching = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var action = url + endpoint.trim().replace(url, '');

  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var form, data, button, request;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!fetching) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              event.preventDefault();
              setError(false);
              setFetching(true);
              form = event.target;
              data = new FormData(form);
              button = form.querySelector('[type="submit"]');
              button && button.setAttribute('disabled', true);
              request = new XMLHttpRequest();
              request.open('POST', action);
              request.setRequestHeader('Accept', 'application/json');

              request.onreadystatechange = function () {
                if (request.readyState !== XMLHttpRequest.DONE) return;

                if (request.status === 200) {
                  setComplete(true);
                } else {
                  setError(true);
                }
              };

              request.send(data);
              setFetching(false);
              button && button.removeAttribute('disabled');

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  if (!endpoint || typeof endpoint !== 'string') {
    return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(NoEndPoint, null, "Create a form on", ' ', /*#__PURE__*/React.createElement(Link, {
      color: "currentColor",
      "text-decoration": "underline",
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://formspree.io/"
    }, "formspree.io"), ' ', "and fill in the ", /*#__PURE__*/React.createElement(Strong, null, "endpoint"), " field on the ", /*#__PURE__*/React.createElement(Strong, null, "props panel")));
  }

  if (!complete) {
    return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement("form", {
      encType: "multipart/form-data",
      method: "post",
      onSubmit: onSubmit,
      action: action
    }, children, error ? /*#__PURE__*/React.createElement(Text, {
      font: "--primary",
      color: "--red"
    }, errorMessage) : null));
  }

  return /*#__PURE__*/React.createElement(Wrapper, rest, completeText);
};

export default atomize(Formspree)({
  name: 'Formspree',
  description: {
    en: 'Formspree — supercharge your forms'
  },
  propInfo: {
    endpoint: {
      weight: 1,
      category: 'Main',
      control: 'input'
    },
    completeText: {
      weight: 1,
      category: 'Main',
      control: 'input'
    },
    errorMessage: {
      weight: 1,
      category: 'Main',
      control: 'input'
    }
  }
}, {
  endpoint: '',
  errorMessage: 'Something went wrong',
  completeText: 'Success'
});